import { render, staticRenderFns } from "./subsidyGoodsList.vue?vue&type=template&id=e0f43444&scoped=true"
import script from "./subsidyGoodsList.vue?vue&type=script&lang=js"
export * from "./subsidyGoodsList.vue?vue&type=script&lang=js"
import style0 from "./subsidyGoodsList.vue?vue&type=style&index=0&id=e0f43444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f43444",
  null
  
)

export default component.exports